import React from 'react'
import { ToastContainer, toast } from 'react-toastify'
import Form from 'react-bootstrap/Form'
import ImageUpload from '../content/ImageUpload'
import AwsConfig from '../../Config/AwsConfig'
import CreateCricketTeam from '../../Services/Mutations/CreateCricketTeam'
import UpdateCricketTeam from '../../Services/Mutations/UpdateCricketTeam'
class CreateOrEditUser extends React.Component {
  toastStyle = {
    position: 'top-right',
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  }
  constructor(props) {
    super(props)
    this.state = {
      teamName: '',
      teamShortName: '',
      teamImage: [],
      selectedTeamImage: '',
      teamLogo: [],
      selectedTeamLogo: '',
    }
  }
  componentDidMount = () => {
    if (this.props.editMode) {
      const { teamName, teamShortName, teamImage, teamLogo } = this.props.itemData
      console.log(this.props.itemData, 'itemData')
      let image = [{ image: teamImage.props.src }]
      let logo = [{ image: teamLogo.props.src }]
      this.setState({
        teamName,
        teamShortName,
        selectedTeamImage: teamImage.props.src,
        selectedTeamLogo: teamLogo.props.src,

        teamImage: image,
        teamLogo: logo,
      })
    }
  }
  handleTeamName = (e) => {
    this.setState({ teamName: e.target.value })
  }
  handleTeamShortName = (e) => {
    this.setState({ teamShortName: e.target.value })
  }
  handleTeamImage = (images) => {
    const imagesArr = []
    images.filter((item) => {
      const obj = {
        image: item.key ? item.key : item.image,
      }
      imagesArr.push(obj)
    })
    this.setState({
      teamImage: images,
      selectedTeamImage: images && images[0] ? images[0].key : '',
    })
  }
  pushImageObj = (imageObj, imageName) => {
    if (imageName == 'teamImage') {
      const { teamImage } = this.state
      teamImage.push(imageObj)
      this.handleTeamImage(teamImage)
    } else {
      const { teamLogo } = this.state
      teamLogo.push(imageObj)
      this.handleTeamLogo(teamLogo)
    }
  }
  removeTeamImage = (imageIndex) => {
    const images = this.state.teamImage
    images.splice(imageIndex, 1)
    this.handleTeamImage(images)
  }

  handleTeamLogo = (images) => {
    const imagesArr = []
    images.filter((item) => {
      const obj = {
        image: item.key ? item.key : item.image,
      }
      imagesArr.push(obj)
    })
    this.setState({
      teamLogo: images,
      selectedTeamLogo: images && images[0] ? images[0].key : '',
    })
  }

  removeTeamLogo = (imageIndex) => {
    const images = this.state.teamLogo
    images.splice(imageIndex, 1)
    this.handleTeamLogo(images)
  }
  createTeam = async () => {
    const { teamName, teamShortName, selectedTeamImage, selectedTeamLogo } = this.state
    let createTeamInput = {
      teamName: teamName,
      teamShortName: teamShortName,
      teamImage: selectedTeamImage,
      teamLogo: selectedTeamLogo,
    }
    if (this.props.editMode) {
      createTeamInput['teamImage'] = selectedTeamImage.substring(
        selectedTeamImage.indexOf('public')
      )
      createTeamInput['teamLogo'] = selectedTeamLogo.substring(selectedTeamLogo.indexOf('public'))
      createTeamInput['PK'] = this.props.itemData.PK
      createTeamInput['SK'] = this.props.itemData.SK
      console.log(createTeamInput, 'createTeamInput')
      const response = await UpdateCricketTeam(createTeamInput)
      console.log(response, 'responseeeee')
      if (response.statusCode == 'A338') {
        toast.success('Cricket Team Updated Successfully', this.toastStyle)
        window.location.reload()
      } else {
        toast.error('Failed to update cricket team', this.toastStyle)
      }
    } else {
      console.log(createTeamInput, 'createTeamInput')
      const response = await CreateCricketTeam(createTeamInput)
      console.log(response, 'responseeeee')
      if (response.statusCode == 'A337') {
        toast.success('Cricket Team Created Successfully', this.toastStyle)
        this.props.history.push('/listTeams')
      } else {
        toast.error('Failed to create cricket team', this.toastStyle)
      }
    }
  }
  checkEnabled = () => {
    const { teamName, teamShortName, selectedTeamImage } = this.state
    return teamName != '' && teamShortName != '' && selectedTeamImage != ''
  }
  render() {
    const isEdit = this.props.editMode
    const { teamImage, teamLogo } = this.state

    return (
      <div className=''>
        <ToastContainer
          position='top-right'
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />

        <section className={this.props.fromList || isEdit ? '' : 'content'}>
          <div className='container-fluid'>
            <div className='row'>
              <div className='card '>
                {/* form start */}
                <div className='card-body'>
                  <div className='row'>
                    <div className={'form-group col-md-12 col-sm-12 '}>
                      <label htmlFor='teamName'>Team Name</label>
                      <div className='input-group '>
                        <input
                          onChange={(e) => this.handleTeamName(e)}
                          type='text'
                          className='form-control'
                          value={this.state.teamName}
                          placeholder='Enter Team Name'
                        />
                      </div>
                    </div>
                  </div>
                  <div className='row'>
                    <div className={'form-group col-md-12 col-sm-12 '}>
                      <label htmlFor='shortName'>Short Name</label>
                      <div className='input-group '>
                        <input
                          type='text'
                          onChange={(e) => this.handleTeamShortName(e)}
                          className='form-control'
                          value={this.state.teamShortName}
                          placeholder='Enter Short Name'
                        />
                      </div>
                    </div>
                  </div>

                  <div className='App'>
                    <label htmlFor='teamLogo'>Choose Team Image</label>

                    <ImageUpload
                      imageName={'teamImage'}
                      pushImageObj={this.pushImageObj}
                      multiImages={false}
                      circularCrop={false}
                    />
                    {teamImage.length > 0 ? null : (
                      <text for='text' style={{ color: 'red', fontSize: 10 }}>
                        Please upload an image
                      </text>
                    )}
                    {teamImage?.map((item, index) => {
                      const { copyRightText, copyRight, shareImage, key, imageValue, image } = item
                      const cdnurl = AwsConfig.cdn_url
                      let finalImage = image ? image : ''
                      if (finalImage && !finalImage.includes(cdnurl)) {
                        finalImage = cdnurl + image
                      }

                      const srcImg = image ? finalImage : imageValue
                      return (
                        <div className='imagesContainer'>
                          <img style={{ maxWidth: '100%' }} src={srcImg} />
                          <button onClick={() => this.removeTeamImage(index)}>Remove Image</button>
                        </div>
                      )
                    })}
                  </div>
                  <div className='App'>
                    <label htmlFor='teamLogo'>Choose Team Logo</label>

                    <ImageUpload
                      imageName={'teamLogo'}
                      pushImageObj={this.pushImageObj}
                      multiImages={false}
                      circularCrop={true}
                    />
                    {teamLogo.length > 0 ? null : (
                      <text for='text' style={{ color: 'red', fontSize: 10 }}>
                        Please upload an image
                      </text>
                    )}
                    {teamLogo?.map((item, index) => {
                      const { copyRightText, copyRight, shareImage, key, imageValue, image } = item
                      const cdnurl = AwsConfig.cdn_url
                      let finalImage = image ? image : ''
                      if (finalImage && !finalImage.includes(cdnurl)) {
                        finalImage = cdnurl + image
                      }

                      const srcImg = image ? finalImage : imageValue
                      return (
                        <div className='imagesContainer'>
                          <img style={{ maxWidth: '100%' }} src={srcImg} />
                          <button onClick={() => this.removeTeamLogo(index)}>Remove Image</button>
                        </div>
                      )
                    })}
                  </div>
                </div>
                {/* /.card-body */}
                <div className='card-footer d-flex justify-content-end'>
                  {this.checkEnabled() ? (
                    <button onClick={() => this.createTeam()} className='btn btn-success mr-2'>
                      Submit
                    </button>
                  ) : (
                    <button disabled className='btn btn-success mr-2'>
                      Submit
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
          {/* /.container-fluid */}
        </section>
      </div>
    )
  }
}

export default CreateOrEditUser
